const headRowsManagementService = {
  date: 'Date',
  equipmentEquipmentParamName: 'Equipment',
  inspection: 'Service Types',
  questions: 'Checklist',
  placeName: 'Local',
  user: 'Performed by',
  description: 'Observation',
  score: 'Score',
};

export default headRowsManagementService;
